import React, { useEffect, useState } from 'react'

/* Monochrome, <= 24x24, `currentColor` fills -- per Meridian's custom-icon guidance. */
import defaultToolSvg from '!svg-inline-loader!@src/assets/icons/default-tool-icon.svg'

interface IToolIconProps {
    src?: string
    label: string
    size: number
}

/** A tool's registered icon, falling back to a generic one when it has none or it fails to load. */
const ToolIcon = ({ src, label, size }: Readonly<IToolIconProps>): React.ReactElement => {
    const [failed, setFailed] = useState(false)

    // A new src is a fresh attempt; otherwise one broken icon poisons the rest.
    useEffect(() => setFailed(false), [src])

    if (!src || failed) {
        return (
            <span
                className="tool-icon-fallback"
                data-atb-id="tool-icon-fallback"
                role="img"
                aria-label={label}
                style={{ width: size, height: size }}
                // Not user input: `defaultToolSvg` is a build-time import from src/assets/icons/.
                dangerouslySetInnerHTML={{ __html: defaultToolSvg }}
            />
        )
    }

    return (
        <img
            src={src}
            alt={label}
            width={size}
            height={size}
            className="tool-icon-image"
            data-atb-id="tool-icon-image"
            onError={() => {
                console.warn(`SMP: Falling back to the default icon, could not load ${src}`)
                setFailed(true)
            }}
        />
    )
}

export default ToolIcon
